import {prod,dev} from "./aws-config"

const config = {  
  ...(process.env.REACT_APP_STAGE === "prod" ? prod : dev),
};

export default config